import { SelectionModel } from '@angular/cdk/collections';
import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { DepartmentsService } from 'src/app/admin/data/services/departments.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';

import { AccountService } from '../../users/data/services/account.service';
import { GroupsDetailsComponent } from '../../groups/groups-details/groups-details.component';

@Component({
  selector: 'app-group-lookup',
  templateUrl: './group-lookup.component.html',
  styleUrls: ['./group-lookup.component.sass']
})
export class GroupLookupComponent implements OnInit {


  displayedColumns: string[] = [
    
    "id",
    "member",
    "number",

   
  ];

  dataSource!: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  
  contextMenu: MatMenuTrigger;

  selection = new SelectionModel<any>(false, []);

 groupDetails: any;
  selectedRows: any[] = [];
  atleastOneSelected: boolean = false;

  dataSourceFilteredList: any[] = [];
 groupArray: any[] = [];

  destroy$: Subject<boolean> = new Subject<boolean>();

  isLoading: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<GroupsDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,
    private snackbar: SnackbarService,
    private communityService: DepartmentsService,
    private accountService: AccountService,
  ) { }

  ngOnInit(): void {

 console.log("check this 1 ", this.data.groupsId);
    this.getData(this.data.groupsId);

  }
  ngAfterViewInit() {

    console.log("Finally: ", this.dataSourceFilteredList);

   
  }


  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  filter() {
    //let storeId = [1, 2, 3];
    this.dataSource.data.forEach((element) => {
      this.groupArray.forEach((item) => {
        if (item === element.id) {
          // this.dataSourceFilteredList.push(this.dataSource.data.indexOf(element));
          this.selection.select(element);
        }
      });
    });

    console.log("dataSourceFilteredList ", this.dataSourceFilteredList);
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  //******************************************************************************************************
  //Select expense

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.data);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "deselect" : "select"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${row.position + 1
      }`;
  }

  expSelected() {
    this.atleastOneSelected = true;
    this.selectedRows = this.selection.selected;

    console.log("this.selectedRows: ", this.selectedRows);
  }
  proceed() {
    this.dialogRef.close({ event: "close", data: this.selectedRows });

    //   console.log(data);
  }

  onNoClick(): void {
    this.dialogRef.close({ event: "close", data: this.selectedRows });
  }
  public confirmAdd(): void { }

  // getData() {
  
  //     console.log("this.group: ", this.groupDetails);

  //     this.dataSource = new MatTableDataSource<any>(this.data.families);
  //     this.dataSource.paginator = this.paginator;
  //     this.dataSource.sort = this.sort;

  //     this.isLoading= false;


  // }

   
  getData(groupsId: any){
    const params = new HttpParams()
    .set("id", this.data.groupsId)

    this.accountService.getGroupById(groupsId).subscribe(
      (res) => {
        let members = res;
        console.log("groupArray 1", res);
        if (res) {
          this.groupArray = res;
          console.log("groupArray 2", res);
        } else {
          console.log("groupArray NotFound", res);
        }
        console.log("groupDetails found: ",members );

            this.dataSource = new MatTableDataSource<any>(members);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
      
            this.isLoading= false;
      
        
      },
      (error) => {
        console.log("groupArray", error);
      }
    );
  }


}

